import { Table } from 'react-bootstrap'

const formatValue = val => {
  if (val === undefined || val === null || val === '') return ''
  const num = Number(val)
  return isNaN(num) ? '' : num.toFixed(2)
}

const TeamTable = ({
  team,
  layout,
  onValueChange,
  tableStyle,
  tacticsTable,
  tacticType,
  tacticSkill,
  onTacticTypeChange,
  onTacticSkillChange,
  className,
  ratingBalance,
  onRatingBalanceChange,
  side,
}) => {
  const sliderValue = ratingBalance
  const displayedBalance = side === 'home' ? -sliderValue : sliderValue
  const directionDescription =
    side === 'home'
      ? 'YlÃ¶s puolustavampi, alas hyÃ¶kkÃ¤Ã¤vÃ¤mpi'
      : 'YlÃ¶s hyÃ¶kkÃ¤Ã¤vÃ¤mpi, alas puolustavampi'

  return (
    <div className="team-table-with-slider">
      {onRatingBalanceChange ? (
        <div className={`rating-balance-slider rating-balance-slider--${side}`}>
          <span>{side === 'home' ? 'Defensive' : 'Offensive'}</span>
          <div className="rating-balance-track">
            <input
              aria-label={`Arvosanojen painotus: ${directionDescription}`}
              type="range"
              min="-100"
              max="100"
              step="10"
              value={sliderValue}
              onChange={event => onRatingBalanceChange(Number(event.target.value))}
              orient="vertical"
            />
            <output
              className="rating-balance-value"
              style={{
                top: `${18 + ((100 - sliderValue) / 200) * 164}px`,
              }}
            >
              {displayedBalance}%
            </output>
          </div>
          <span>{side === 'home' ? 'Offensive' : 'Defensive'}</span>
        </div>
      ) : null}
      <Table
    striped
    bordered
    hover
    variant="dark"
    size="sm"
    className={className}
    style={{ ...(tableStyle || {}), width: '100%' }}
      >
        <tbody>
      {layout.map((row, i) => (
        <tr key={i}>
          {row.map((field, j) =>
            field === '' ? (
              <td key={j}></td>
            ) : (
              <td
                key={j}
                style={{
                  minWidth: 110,
                  textAlign: 'center',
                  position: 'relative',
                }}
              >
                <div style={{ fontSize: 11, color: '#aaa', marginBottom: 2 }}>
                  {field}
                </div>
                <input
                  type="number"
                  step="0.25"
                  min="1"
                  max="50"
                  value={formatValue(team[field])}
                  style={{ width: 70, textAlign: 'center', marginBottom: 2 }}
                  onChange={e =>
                    onValueChange(
                      field,
                      Math.max(1, Math.min(50, Number(e.target.value)))
                    )
                  }
                />
                <div
                  style={{
                    position: 'absolute',
                    right: 4,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '2px',
                  }}
                ></div>
              </td>
            )
          )}
          {/* Lisää taktiikkasolu viimeisen solun jälkeen viimeiselle riville */}
          {i === layout.length - 1 && (
            <td
              key="tactics"
              style={{
                minWidth: 110,
                textAlign: 'center',
                position: 'relative',
              }}
            >
              <div style={{ fontSize: 11, color: '#aaa', marginBottom: 2 }}>
                Tactic / Skill
              </div>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 6,
                }}
              >
                <select
                  value={tacticType}
                  onChange={e => onTacticTypeChange(Number(e.target.value))}
                  style={{ width: 90, marginBottom: 0, fontSize: 13 }}
                >
                  {Object.entries(tacticsTable || {}).map(([key, label]) => (
                    <option key={key} value={key}>
                      {label}
                    </option>
                  ))}
                </select>
                <input
                  type="number"
                  min="1"
                  max="33"
                  step="1"
                  value={tacticSkill}
                  style={{ width: 40, textAlign: 'center', fontSize: 13 }}
                  onChange={e =>
                    onTacticSkillChange(
                      Math.max(1, Math.min(33, Number(e.target.value)))
                    )
                  }
                />
              </div>
            </td>
          )}
        </tr>
      ))}
        </tbody>
      </Table>
    </div>
  )
}

export default TeamTable
